export default __webpack_public_path__ + "static/media/delievers5.0c5ca7ea.png";